// Head data for editorial guides, shared by the interactive page (DynamicPage) and the build-time prerender,
// so the initial HTML and the hydrated DOM carry the same structured data.
import { canonicalUrl } from './seoPolicy';

export function breadcrumbJsonLd(guide) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: canonicalUrl('/') },
      { '@type': 'ListItem', position: 2, name: guide.breadcrumb.categoryName, item: canonicalUrl(`/category/${guide.breadcrumb.categorySlug}`) },
      { '@type': 'ListItem', position: 3, name: guide.title },
    ],
  };
}

/** JSON for a <script type="application/ld+json"> body: "<" is escaped so the data can never close the script tag. */
export function safeJsonLd(value) {
  return JSON.stringify(value).replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}
